(function($, window) {
  /**
   * Create empty global functions for internal usage
   * @since 1.0
   */
  if ('undefined' === typeof window.TL)
    window.TL = {};

  /**
   * Set app data to use foe whole site
   * @since 2019-03-05
   * 
   * @update 2019-05-30
   * @desc Also create empty ui object at once
   */
  $.extend(true, window.TL, {
    app: {
      path: location.origin + '/travelanium-crs',
      language: null,
      currency: null,
      calendar: {
        checkin: new Date(),
        checkout: new Date( new Date().getTime() + 1000*3600*24 ),
        disabledDate: [
          '2019-05-21',
          '2019-05-23',
          '2019-05-24',
          '2019-06-15',
          '2019-06-16'
        ]
      }
    },
    ui: {},
    i18n: {
      "night": 'night',
      "nights": 'nights',
      "no-reservation-date-select": "Please select reservation date"
    }
  });
})(jQuery, window);